module.exports = __webpack_public_path__ + "static/media/SYN.a1c87985.svg";